<template>
  <section>
    <h3 class="section-title small with-border">
      <v-icon color="deep-orange darken-2">fal fa-ruler</v-icon>
      Perimetria
    </h3>
    <v-layout row wrap align-center>
      <v-flex xs12 md3>
        <v-text-field suffix="kg" label="Peso Corporal" v-model="currentEvaluationForm.body_weight"
          hide-details required type="number"></v-text-field>
      </v-flex>
      <v-flex xs12 md3>
        <v-text-field suffix="%" label="Gordura Corporal" v-model="currentEvaluationForm.body_fat"
          hide-details required type="number"></v-text-field>
      </v-flex>
      <v-flex xs12 md3>
        <v-text-field suffix="cm" label="Peitoral relaxado" v-model="currentEvaluationForm.pectoral"
          hide-details required type="number"></v-text-field>
      </v-flex>
      <v-flex xs12 md3>
        <v-text-field suffix="cm" label="Peitoral inspirado" v-model="currentEvaluationForm.pectoral_contracted"
          hide-details required type="number"></v-text-field>
      </v-flex>
      <!-- _____________________________________ -->
      <v-flex xs12 md3>
        <v-text-field suffix="cm" label="Antebraço direito" v-model="currentEvaluationForm.right_forearm"
          hide-details required type="number"></v-text-field>
      </v-flex>
      <v-flex xs12 md3>
        <v-text-field suffix="cm" label="Antebraço esquerdo" v-model="currentEvaluationForm.left_forearm"
          hide-details required type="number"></v-text-field>
      </v-flex>
      <v-flex xs12 md3>
        <v-text-field suffix="cm" label="Braço dir. relaxado" v-model="currentEvaluationForm.right_midarm"
          hide-details required type="number"></v-text-field>
      </v-flex>
      <v-flex xs12 md3>
        <v-text-field suffix="cm" label="Braço dir. contraído" v-model="currentEvaluationForm.right_midarm_contracted"
          hide-details required type="number"></v-text-field>
      </v-flex>
      <!-- _____________________________________ -->
      <v-flex xs12 md3>
        <v-text-field suffix="cm" label="Braço esq. relaxado" v-model="currentEvaluationForm.left_midarm"
          hide-details required type="number"></v-text-field>
      </v-flex>
      <v-flex xs12 md3>
        <v-text-field suffix="cm" label="Braço esq. contraído" v-model="currentEvaluationForm.left_midarm_contracted"
          hide-details required type="number"></v-text-field>
      </v-flex>
      <v-flex xs12 md3>
        <v-text-field suffix="cm" label="Cintura" v-model="currentEvaluationForm.waist"
          hide-details required type="number"></v-text-field>
      </v-flex>
      <v-flex xs12 md3>
        <v-text-field suffix="cm" label="Abdome" v-model="currentEvaluationForm.abdome"
          hide-details required type="number"></v-text-field>
      </v-flex>
      <!-- _____________________________________ -->
      <v-flex xs12 md3>
        <v-text-field suffix="cm" label="Quadril" v-model="currentEvaluationForm.hip"
          hide-details required type="number"></v-text-field>
      </v-flex>
      <v-flex xs12 md3>
        <v-text-field suffix="cm" label="Pescoço" v-model="currentEvaluationForm.neck"
          hide-details required type="number"></v-text-field>
      </v-flex>
      <v-flex xs12 md3>
        <v-text-field suffix="cm" label="Panturrilha direita" v-model="currentEvaluationForm.right_calf"
          hide-details required type="number"></v-text-field>
      </v-flex>
      <v-flex xs12 md3>
        <v-text-field suffix="cm" label="Panturrilha esquerda" v-model="currentEvaluationForm.left_calf"
          hide-details required type="number"></v-text-field>
      </v-flex>
      <!-- _____________________________________ -->
      <v-flex xs12 md3>
        <v-text-field suffix="cm" label="Coxa direita" v-model="currentEvaluationForm.right_thigh"
          hide-details required type="number"></v-text-field>
      </v-flex>
      <v-flex xs12 md3>
        <v-text-field suffix="cm" label="Coxa esquerda" v-model="currentEvaluationForm.left_thigh"
          hide-details required type="number"></v-text-field>
      </v-flex>
      <v-flex xs12 md3>
        <v-text-field suffix="cm" label="Coxa baixa esquerda" v-model="currentEvaluationForm.left_low_thigh"
          hide-details required type="number"></v-text-field>
      </v-flex>
      <v-flex xs12 md3>
        <v-text-field suffix="cm" label="Coxa baixa direita" v-model="currentEvaluationForm.right_low_thigh"
          hide-details required type="number"></v-text-field>
      </v-flex>
      <!-- _____________________________________ -->
      <v-flex xs12 md12>
        <h4>Diametro ósseo</h4>
      </v-flex>
      <v-flex xs12 md4>
        <v-text-field suffix="cm" label="Punho" v-model="currentEvaluationForm.fist"
          hide-details required type="number"></v-text-field>
      </v-flex>
      <v-flex xs12 md4>
        <v-text-field suffix="cm" label="Fêmur" v-model="currentEvaluationForm.femur"
          hide-details required type="number"></v-text-field>
      </v-flex>

      <!-- _____________________________________ -->
      <template v-if="currentEvaluationForm.skinfolds">
        <v-flex xs12 md12>
          <h4><strong>Dobras cutâneas</strong></h4>
        </v-flex>

        <!-- _____________________________________ -->
        <v-flex xs12 md6 style="background: rgba(0,0,0, 0.05); padding: 15px;">
          <p>
            <strong>Tricipital</strong>
            {{ calculateSkinFoldsAverage(currentEvaluationForm.skinfolds.triceps) }}
          </p>
          <v-layout row wrap align-center>
            <v-flex xs12 md4>
              <v-text-field suffix="cm" label="1ª" v-model="currentEvaluationForm.skinfolds.triceps.first"
                hide-details required type="number"></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field suffix="cm" label="2ª" v-model="currentEvaluationForm.skinfolds.triceps.second"
                hide-details required type="number"></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field suffix="cm" label="3ª" v-model="currentEvaluationForm.skinfolds.triceps.third"
                hide-details required type="number"></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs12 md6 style="background: rgba(0,0,0, 0.05); padding: 15px;">
          <p>
            <strong>Bicipital</strong>
            {{ calculateSkinFoldsAverage(currentEvaluationForm.skinfolds.biceps) }}
          </p>
          <v-layout row wrap align-center>
            <v-flex xs12 md4>
              <v-text-field suffix="cm" label="1ª" v-model="currentEvaluationForm.skinfolds.biceps.first"
                hide-details required type="number"></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field suffix="cm" label="2ª" v-model="currentEvaluationForm.skinfolds.biceps.second"
                hide-details required type="number"></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field suffix="cm" label="3ª" v-model="currentEvaluationForm.skinfolds.biceps.third"
                hide-details required type="number"></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
        <!-- _____________________________________ -->

        <!-- _____________________________________ -->
        <v-flex xs12 md6 style="background: rgba(0,0,0, 0.05); padding: 15px;">
          <p>
            <strong>Subescapular</strong>
            {{ calculateSkinFoldsAverage(currentEvaluationForm.skinfolds.subscapular) }}
          </p>
          <v-layout row wrap align-center>
            <v-flex xs12 md4>
              <v-text-field suffix="cm" label="1ª" v-model="currentEvaluationForm.skinfolds.subscapular.first"
                hide-details required type="number"></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field suffix="cm" label="2ª" v-model="currentEvaluationForm.skinfolds.subscapular.second"
                hide-details required type="number"></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field suffix="cm" label="3ª" v-model="currentEvaluationForm.skinfolds.subscapular.third"
                hide-details required type="number"></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs12 md6 style="background: rgba(0,0,0, 0.05); padding: 15px;">
          <p>
            <strong>Peitoral</strong>
            {{ calculateSkinFoldsAverage(currentEvaluationForm.skinfolds.chest) }}
          </p>
          <v-layout row wrap align-center>
            <v-flex xs12 md4>
              <v-text-field suffix="cm" label="1ª" v-model="currentEvaluationForm.skinfolds.chest.first"
                hide-details required type="number"></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field suffix="cm" label="2ª" v-model="currentEvaluationForm.skinfolds.chest.second"
                hide-details required type="number"></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field suffix="cm" label="3ª" v-model="currentEvaluationForm.skinfolds.chest.third"
                hide-details required type="number"></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
        <!-- _____________________________________ -->

        <!-- _____________________________________ -->
        <v-flex xs12 md6 style="background: rgba(0,0,0, 0.05); padding: 15px;">
          <p>
            <strong>Axilar</strong>
            {{ calculateSkinFoldsAverage(currentEvaluationForm.skinfolds.armpit) }}
          </p>
          <v-layout row wrap align-center>
            <v-flex xs12 md4>
              <v-text-field suffix="cm" label="1ª" v-model="currentEvaluationForm.skinfolds.armpit.first"
                hide-details required type="number"></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field suffix="cm" label="2ª" v-model="currentEvaluationForm.skinfolds.armpit.second"
                hide-details required type="number"></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field suffix="cm" label="3ª" v-model="currentEvaluationForm.skinfolds.armpit.third"
                hide-details required type="number"></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs12 md6 style="background: rgba(0,0,0, 0.05); padding: 15px;">
          <p>
            <strong>Ilíaca</strong>
            {{ calculateSkinFoldsAverage(currentEvaluationForm.skinfolds.iliac) }}
          </p>
          <v-layout row wrap align-center>
            <v-flex xs12 md4>
              <v-text-field suffix="cm" label="1ª" v-model="currentEvaluationForm.skinfolds.iliac.first"
                hide-details required type="number"></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field suffix="cm" label="2ª" v-model="currentEvaluationForm.skinfolds.iliac.second"
                hide-details required type="number"></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field suffix="cm" label="3ª" v-model="currentEvaluationForm.skinfolds.iliac.third"
                hide-details required type="number"></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
        <!-- _____________________________________ -->

        <!-- _____________________________________ -->
        <v-flex xs12 md6 style="background: rgba(0,0,0, 0.05); padding: 15px;">
          <p>
            <strong>Supraespinhal</strong>
            {{ calculateSkinFoldsAverage(currentEvaluationForm.skinfolds.supraspinatus) }}
          </p>

          <v-layout row wrap align-center>
            <v-flex xs12 md4>
              <v-text-field suffix="cm" label="1ª" v-model="currentEvaluationForm.skinfolds.supraspinatus.first"
                hide-details required type="number"></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field suffix="cm" label="2ª" v-model="currentEvaluationForm.skinfolds.supraspinatus.second"
                hide-details required type="number"></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field suffix="cm" label="3ª" v-model="currentEvaluationForm.skinfolds.supraspinatus.third"
                hide-details required type="number"></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs12 md6 style="background: rgba(0,0,0, 0.05); padding: 15px;">
          <p>
            <strong>Abdominal</strong>
            {{ calculateSkinFoldsAverage(currentEvaluationForm.skinfolds.abdominal) }}
          </p>
          <v-layout row wrap align-center>
            <v-flex xs12 md4>
              <v-text-field suffix="cm" label="1ª" v-model="currentEvaluationForm.skinfolds.abdominal.first"
                hide-details required type="number"></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field suffix="cm" label="2ª" v-model="currentEvaluationForm.skinfolds.abdominal.second"
                hide-details required type="number"></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field suffix="cm" label="3ª" v-model="currentEvaluationForm.skinfolds.abdominal.third"
                hide-details required type="number"></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
        <!-- _____________________________________ -->

        <!-- _____________________________________ -->
        <v-flex xs12 md6 style="background: rgba(0,0,0, 0.05); padding: 15px;">
          <p>
            <strong>Coxa</strong>
            {{ calculateSkinFoldsAverage(currentEvaluationForm.skinfolds.thigh) }}
          </p>

          <v-layout row wrap align-center>
            <v-flex xs12 md4>
              <v-text-field suffix="cm" label="1ª" v-model="currentEvaluationForm.skinfolds.thigh.first"
                hide-details required type="number"></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field suffix="cm" label="2ª" v-model="currentEvaluationForm.skinfolds.thigh.second"
                hide-details required type="number"></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field suffix="cm" label="3ª" v-model="currentEvaluationForm.skinfolds.thigh.third"
                hide-details required type="number"></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs12 md6 style="background: rgba(0,0,0, 0.05); padding: 15px;">
          <p>
            <strong>Panturrilha</strong>
            {{ calculateSkinFoldsAverage(currentEvaluationForm.skinfolds.calf) }}
          </p>
          <v-layout row wrap align-center>
            <v-flex xs12 md4>
              <v-text-field suffix="cm" label="1ª" v-model="currentEvaluationForm.skinfolds.calf.first"
                hide-details required type="number"></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field suffix="cm" label="2ª" v-model="currentEvaluationForm.skinfolds.calf.second"
                hide-details required type="number"></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field suffix="cm" label="3ª" v-model="currentEvaluationForm.skinfolds.calf.third"
                hide-details required type="number"></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
        <!-- _____________________________________ -->
      </template>
    </v-layout>

    <v-card-actions v-if="!isAdmin">
      <v-spacer></v-spacer>
      <v-btn @click.stop="create()" round large depressed color="success" :loading="loadingRequest">
        <span v-if="currentEvaluationForm._id">Salvar AVALIAÇÃO</span>
        <span v-else>ENVIAR AVALIAÇÃO</span>
      </v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </section>
</template>

<script>
import EventBus from '@/event-bus'
import axios from 'axios'

export default {
  props: ['currentEvaluationForm', 'user', 'isAdmin'],

  data: () => ({
    currentUser: {},
    loadingRequest: false
  }),

  methods: {
    create () {
      this.getUser()
      this.loadingRequest = true
      // eslint-disable-next-line
      let path = `${API.userEvaluations}/users/${this.currentUser._id}`
      let $request

      if (this.currentEvaluationForm._id) {
        // eslint-disable-next-line
        $request = axios.put(`${API.userEvaluations}/${this.currentEvaluationForm._id}`, this.currentEvaluationForm)
      } else {
        // eslint-disable-next-line
        $request = axios.post(`${API.userEvaluations}/users/${this.currentUser._id}`, this.currentEvaluationForm)
      }

      $request.then(response => {
        this.loadingRequest = false
        EventBus.$emit('evaluationCurrentStep', 2)
        EventBus.$emit('loadEvaluationPhoto', response.data.evaluation)
      }).catch(errors => {
        EventBus.$emit('showSnackbar', {
          message: 'Erro ao salvar a avaliação',
          color: 'error'
        })
        this.loadingRequest = false
      })
    },

    getUser () {
      if (!this.user) {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'))
      } else {
        this.currentUser = this.user
      }
    },

    getEvaluation () {
      if (this.evaluation) {
        this.currentEvaluationForm = this.evaluation
      }
    },

    calculateSkinFoldsAverage (item) {
      if (!item || !item.first || !item.second || !item.third) return ''

      const sum = parseInt(item.first) + parseInt(item.second) + parseInt(item.third)
      const total = sum / 3

      return `Média: ${total} cm`
    }
  },

  mounted () {
    this.getEvaluation()
    this.getUser()
  }
}
</script>

<style scoped>
.v-input.v-text-field {
  padding: 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/evaluations/UserEvaluationsItemForm.vue